Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById("footerContact")) {
        const footerContact = new Vue({
            el: '#footerContact',
            store,
            data: function () {
                return {}
            },
            computed: {},
            mounted: function () {
                this.watchFormSubmit();
            },
            methods: {
                watchFormSubmit: function () {
                    let that = this;
                    let form = document.getElementById("footerContact");

                    form.addEventListener("submit", function (e) {
                        e.preventDefault();

                        that.$validator.validateAll().then(result => {
                            if (result) {
                                Global.SubmitForm(form, 'Footer Contact');
                            }
                        });
                    });
                },
            },
            created: function () {
            },
            destroyed: function () {
            }
        });
    }
});
